import { Field, FieldError, FieldLabel } from '@wedding-tech/ui/field'

import { useFieldContext } from '@/lib/forms/context'
import { cn } from '@/lib/utils'

import { RadioGroup, RadioGroupItem } from '../ui/radio-group'

type Props = {
  label: string
  options: { value: string; label: string }[]
  className?: string
  itemClassName?: string
}

export const RadioField = ({
  label,
  options,
  className,
  itemClassName,
}: Props) => {
  const field = useFieldContext<string>()

  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid

  return (
    <Field data-invalid={isInvalid}>
      <FieldLabel
        htmlFor={field.name}
        className="text-foreground text-base font-bold"
      >
        {label}
      </FieldLabel>
      <RadioGroup
        value={field.state.value}
        onValueChange={(val) => field.handleChange(val)}
        className={cn('flex flex-wrap gap-3', className)}
      >
        {options.map((option) => (
          <div
            key={option.value}
            className={cn('flex items-center space-x-2', itemClassName)}
          >
            <RadioGroupItem
              value={option.value}
              id={`${field.name}-${option.value}`}
            />
            <label
              htmlFor={`${field.name}-${option.value}`}
              className="cursor-pointer text-sm"
            >
              {option.label}
            </label>
          </div>
        ))}
      </RadioGroup>
      {isInvalid && <FieldError errors={field.state.meta.errors} />}
    </Field>
  )
}
